import { Component, OnInit } from '@angular/core'
import { MessageService } from 'src/app/components/message/message.service'
import { ImportantNoticeSetting, NavService } from 'src/app/components/nav/nav.service'
import { ConfirmService } from 'src/app/module/common-parts/confirm/confirm.service'

@Component({
  selector: 'app-ura-important-notice-setting-edit',
  templateUrl: './ura-important-notice-setting-edit.component.html',
  styleUrls: ['./ura-important-notice-setting-edit.component.scss']
})
export class UraImportantNoticeSettingEditComponent implements OnInit {
  title = '重要なお知らせマスタ管理'
  loading = false
  sending = false
  setting: ImportantNoticeSetting = this.createDefaultSetting()
  popupListItemsText = ''
  endDatetimeLocal = ''

  constructor(
    private navService: NavService,
    private messageService: MessageService,
    private confirmService: ConfirmService
  ) {}

  ngOnInit(): void {
    this.loadSetting()
  }

  async loadSetting(): Promise<void> {
    this.loading = true
    const data = await this.navService.getImportantNoticeJson()
    this.loading = false

    this.setting = this.normalizeSetting(data)
    this.endDatetimeLocal = this.toDatetimeLocal(this.setting.endDatetime)
    this.popupListItemsText = this.setting.popup.listItems.join('\n')
  }

  save(): void {
    if (this.sending) {
      return
    }

    this.confirmService.confirm('本当に更新しますか？', '', async () => {
      const payload = this.buildPayload()
      this.sending = true
      const success = await this.navService.saveImportantNoticeJson(payload)
      this.sending = false
      if (!success) {
        this.messageService.error('更新に失敗しました')
        return
      }

      this.messageService.success('更新しました')
      this.setting = this.normalizeSetting(payload)
      this.endDatetimeLocal = this.toDatetimeLocal(this.setting.endDatetime)
      this.popupListItemsText = this.setting.popup.listItems.join('\n')
    })
  }

  private buildPayload(): ImportantNoticeSetting {
    return {
      ...this.setting,
      endDatetime: this.toDisplayDatetime(this.endDatetimeLocal),
      popup: {
        ...this.setting.popup,
        listItems: this.popupListItemsText
          .split(/\r?\n/)
          .map((item) => item.trim())
          .filter((item) => !!item)
      }
    }
  }

  private toDatetimeLocal(value: string): string {
    if (!value) {
      return ''
    }

    const text = value.trim()
    const matched = text.match(
      /^(\d{4})[/-](\d{2})[/-](\d{2})[ T](\d{2}):(\d{2})(?::\d{2})?$/
    )
    if (matched) {
      const [, year, month, day, hours, minutes] = matched
      return `${year}-${month}-${day}T${hours}:${minutes}`
    }

    const normalized = text.replace(/\//g, '-').replace(' ', 'T')
    const date = new Date(normalized)
    if (Number.isNaN(date.getTime())) {
      return ''
    }
    const year = date.getFullYear()
    const month = `${date.getMonth() + 1}`.padStart(2, '0')
    const day = `${date.getDate()}`.padStart(2, '0')
    const hours = `${date.getHours()}`.padStart(2, '0')
    const minutes = `${date.getMinutes()}`.padStart(2, '0')
    return `${year}-${month}-${day}T${hours}:${minutes}`
  }

  private toDisplayDatetime(localValue: string): string {
    if (!localValue) {
      return ''
    }

    const [datePart, timePart] = localValue.split('T')
    if (!datePart || !timePart) {
      return ''
    }

    return `${datePart.replace(/-/g, '/')} ${timePart}:00`
  }

  private createDefaultSetting(): ImportantNoticeSetting {
    return {
      notificationDivision: '',
      buttonTitle: '',
      buttonText: '',
      showPopupOnTopPage: false,
      popup: {
        title: '',
        content: '',
        listItems: [],
        linkText: '',
        closeButtonText: '閉じる'
      },
      linkUrl: '',
      actionTransactionKey: '',
      endDatetime: ''
    }
  }

  private normalizeSetting(data: ImportantNoticeSetting): ImportantNoticeSetting {
    const base = this.createDefaultSetting()
    return {
      ...base,
      ...(data || {}),
      popup: {
        ...base.popup,
        ...(data?.popup || {}),
        listItems: data?.popup?.listItems || []
      }
    }
  }
}
